import styled from 'styled-components';

import {
  Components, FontFamily, FontSize, ThemeProps as Prop,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

const CPNT = Components.EVENT_CALENDAR;

export const StyledEventCalendar = styled.div`
  ${() => getFontStyles(FontFamily.BASE_FONT, FontSize.REG50, undefined, undefined)};

  button,
  a {
    font-family: inherit;
  }

  .rbc-calendar {
    ${() => getFontStyles(FontFamily.BASE_FONT, FontSize.REG50, undefined, undefined)};
  }

  .rbc-toolbar {
    margin-bottom: 16px;
  }

  .rbc-header {
    padding: 10px 4px;
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG40, undefined, undefined)};
  }

  .rbc-date-cell {
    padding: 5px 5px;
    ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.REG40, undefined, undefined)};
  }

  .rbc-row-segment {
    padding: 0 0 5px 0;
  }

  .rbc-off-range-bg {
    background: transparent;
    opacity: 0.45;
  }

  .rbc-today {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BACKGROUND, CPNT, $colorProfile)};
  }

  a.event-calendar-event-link {
    display: block;
    color: inherit;
    text-decoration: none;
  }

  .rbc-event {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT, CPNT, $colorProfile)};
    border: none;
    padding: 5px 5px;
    border-radius: unset;
    transition: color 0.25s ease-out, background-color 0.25s ease-out;
    ${() => getFontStyles(FontFamily.BASE_FONT, FontSize.REG50, undefined, undefined)};
  }

  .rbc-month-row {
    overflow: visible;
  }

  .rbc-event:hover,
  .rbc-event:active,
  .rbc-event.rbc-selected,
  a.event-calendar-event-link:focus .rbc-event,
  a.event-calendar-event-link:active .rbc-event {
    background-color: ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
    color: ${({ $colorProfile }) => themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile)};
  }

  a.event-calendar-event-link:focus {
    outline: 2px solid ${({ $colorProfile }) => themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile)};
    outline-offset: 2px;
    position: relative;
    z-index: 6;
  }

  .rbc-show-more {
    color: ${({ $colorProfile }) => themeUtil(Prop.LINK_TXT, CPNT, $colorProfile)};
    font-weight: 600;
    ${() => getFontStyles(FontFamily.BASE_FONT, FontSize.REG30, undefined, undefined)};
  }

  .rbc-overlay {
    z-index: 5;
    ${() => getFontStyles(FontFamily.BASE_FONT, FontSize.REG40, undefined, undefined)};
  }
`;
